$ ->
  if $('#js-surveys-answer').length > 0
    $.ajax
      type: 'GET',
      url: $('#js-surveys-answer').data('url'),
      dataType: 'html'
    .done (data, stat, xhr) ->
      $('#js-surveys-answer').html(data)
      formValidate()
    .fail (xhr, stat, data) ->
      $('#js-surveys-answer').remove()

    $('#js-surveys-answer')
      .on 'ajax:success', 'form', (event) ->
        $('#js-surveys-answer').html(event.detail[2].responseText)
        formValidate()
        $('html,body').animate({ scrollTop: $('#js-surveys-answer').offset().top - 60 }, 400)
      .on 'ajax:error', 'form', (event) ->
        $('#js-surveys-answer').remove()
      .on 'change', 'form', (event) ->
        formValidate()

    formValidate = ->
      $form = $('#js-surveys-answer form')
      required_textarea = $form.find('[data-required] textarea').get().every (elm) -> $(elm).val() != ''
      required_checkable = $form.find('[data-required][data-checkable]').get().every (elm) -> $(elm).find('input').is(':checked')

      $form.find(':submit').prop('disabled', !(required_checkable && required_textarea))
